import { isComponentSchema } from "./is-component-schema";
export function isLowcodeProjectSchema(data) {
  return data && data.componentsTree && data.componentsTree.length && isComponentSchema(data.componentsTree[0]);
}